import { RangeDatepicker } from "chakra-dayzed-datepicker";
import { FC } from "react";

interface RangeDatePickerProps {
    selectedDate: any,
    setSelectedDates: any
};

const RangeDatePicker: FC<RangeDatePickerProps> = ({ selectedDate, setSelectedDates }) => {
    const propsConfigs = {
        dateNavBtnProps: {
            colorScheme: "teal"
        },
        dayOfMonthBtnProps: {
            defaultBtnProps: {
                borderColor: "teal.900",
                _hover: {
                    background: 'teal.400',
                }
            },
            isInRangeBtnProps: {
                background: 'teal.100',
                color: "black",
            },
            selectedBtnProps: {
                background: "teal.900",
                color: "white",
            },
            todayBtnProps: {
                background: "teal.400",
                color: "white"
            }
        },
        inputProps: {
            size: "sm"
        }
    };

    return (
        <RangeDatepicker
            selectedDates={selectedDate}
            onDateChange={setSelectedDates}
            propsConfigs={propsConfigs}
        />
    );
};

export default RangeDatePicker;